(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xihe-editorial-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xihe-editorial-videos')) {
    customElements.define('xihe-editorial-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const controller = new AbortController();
        const options = { signal: controller.signal };
        const track = this.querySelector('.xev__track');
        const dialog = this.querySelector('dialog');
        const player = this.querySelector('.xev__player');
        let activeVideo = null;
        let originalHost = null;
        let opener = null;
        const arrows = [...this.querySelectorAll('[data-step]')];
        const visible = new Set();
        const pending = new WeakSet();
        const inlineVideos = () => [...this.querySelectorAll('.xev__inline video')];
        const silence = video => {
          video.muted = true;
          video.defaultMuted = true;
          video.volume = 0;
          video.controls = false;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.playsInline = true;
          video.addEventListener('volumechange', () => {
            if (!video.muted) video.muted = true;
            if (video.volume !== 0) video.volume = 0;
          }, options);
        };
        const start = video => {
          if (!video.paused || pending.has(video)) return;
          pending.add(video);
          video.play().catch(() => {}).finally(() => pending.delete(video));
        };
        const sync = () => {
          inlineVideos().forEach(video => {
            if (visible.has(video.closest('.xev__card')) && !document.hidden && !dialog.open && !video.dataset.userPaused) start(video);
            else video.pause();
          });
        };
        const cards = [...this.querySelectorAll('.xev__card')].filter(card => card.querySelector('template'));
        const refresh = () => {
          const clip = track.getBoundingClientRect();
          const viewportHeight = document.documentElement.clientHeight;
          cards.forEach(card => {
            const rect = card.querySelector('.xev__media').getBoundingClientRect();
            const width = Math.max(0, Math.min(rect.right, clip.right, document.documentElement.clientWidth) - Math.max(rect.left, clip.left, 0));
            const height = Math.max(0, Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0));
            if (rect.width > 0 && rect.height > 0 && width >= rect.width * .5 && height >= Math.min(rect.height * .15, 80)) {
              visible.add(card);
              const host = card.querySelector('.xev__inline');
              if (!host.firstChild) {
                const fragment = card.querySelector('template').content.cloneNode(true);
                const video = fragment.querySelector('video');
                silence(video);
                video.autoplay = true;
                video.setAttribute('autoplay', '');
                video.preload = 'auto';
                video.addEventListener('loadedmetadata', sync, options);
                video.addEventListener('loadeddata', sync, options);
                video.addEventListener('canplay', sync, options);
                host.append(fragment);
                video.load();
              }
            } else visible.delete(card);
          });
          sync();
        };
        const visibility = new IntersectionObserver(refresh, { threshold: [0, .15, .5] });
        cards.forEach(card => visibility.observe(card.querySelector('.xev__media')));
        let frame = 0;
        const schedule = () => { if (!frame) frame = requestAnimationFrame(() => { frame = 0; refresh(); }); };
        window.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
        window.addEventListener('resize', schedule, options);
        window.addEventListener('pageshow', schedule, options);
        track.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
        this.querySelectorAll('.xev__pause').forEach(button => button.addEventListener('click', () => {
          const video = button.closest('li, dialog').querySelector('video');
          if (!video) return;
          if (video.paused) {
            delete video.dataset.userPaused;
            video.play().catch(() => {});
          } else {
            video.dataset.userPaused = 'true';
            video.pause();
          }
          button.setAttribute('aria-pressed', String(Boolean(video.dataset.userPaused)));
          button.querySelector('span').textContent = video.dataset.userPaused ? '\u25b7' : '\u275a\u275a';
        }, options));
        const update = () => {
          arrows[0].disabled = track.scrollLeft <= 2;
          arrows[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        arrows.forEach(button => button.addEventListener('click', () => {
          const card = track.querySelector('.xev__card');
          if (!card) return;
          track.scrollBy({ left: Number(button.dataset.step) * (card.offsetWidth + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options));
        const releasePlayer = () => {
          if (!activeVideo) return;
          activeVideo.pause();
          activeVideo.controls = false;
          activeVideo.removeAttribute('controls');
          if (originalHost?.isConnected) originalHost.append(activeVideo);
          activeVideo = null;
          originalHost = null;
          player.replaceChildren();
          opener?.focus({ preventScroll: true });
          opener = null;
          refresh();
        };
        const closePlayer = () => {
          if (typeof dialog.close === 'function' && !dialog.hasAttribute('data-fallback')) dialog.close();
          else dialog.removeAttribute('open');
          releasePlayer();
        };
        this.querySelectorAll('.xev__open').forEach(button => button.addEventListener('click', () => {
          if (dialog.open || activeVideo) return;
          const card = button.closest('li');
          const host = card.querySelector('.xev__inline');
          let video = host.querySelector('video');
          if (!video) {
            video = card.querySelector('template').content.querySelector('video').cloneNode(true);
            silence(video);
            video.preload = 'auto';
            host.append(video);
          }
          opener = button;
          originalHost = host;
          activeVideo = video;
          delete video.dataset.userPaused;
          player.replaceChildren(video);
          dialog.querySelector('.xev__pause').setAttribute('aria-pressed', 'false');
          dialog.querySelector('.xev__pause span').textContent = '\u275a\u275a';
          try {
            if (typeof dialog.showModal === 'function') dialog.showModal();
            else {
              dialog.setAttribute('data-fallback', '');
              dialog.setAttribute('open', '');
              dialog.setAttribute('aria-modal', 'true');
            }
          } catch (error) {
            dialog.setAttribute('data-fallback', '');
            dialog.setAttribute('open', '');
            dialog.setAttribute('aria-modal', 'true');
          }
          sync();
          const playing = video.play();
          if (playing) playing.catch(() => {
            if (activeVideo === video && dialog.open) video.controls = true;
          });
          dialog.querySelector('.xev__close').focus({ preventScroll: true });
        }, options));
        this.querySelector('.xev__close').addEventListener('click', closePlayer, options);
        dialog.addEventListener('click', event => { if (event.target === dialog) closePlayer(); }, options);
        dialog.addEventListener('close', releasePlayer, options);
        dialog.addEventListener('keydown', event => {
          if (!dialog.hasAttribute('data-fallback')) return;
          if (event.key === 'Escape') { event.preventDefault(); closePlayer(); }
          if (event.key === 'Tab') {
            const buttons = [...dialog.querySelectorAll('button')];
            const first = buttons[0];
            const last = buttons[buttons.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
        }, options);
        track.addEventListener('scroll', update, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) player.querySelector('video')?.pause(); refresh(); }, options);
        const observer = new ResizeObserver(() => { update(); schedule(); });
        observer.observe(track);
        update();
        refresh();
        this.cleanup = () => { cancelAnimationFrame(frame); visible.clear(); inlineVideos().forEach(video => video.pause()); player.querySelector('video')?.pause(); controller.abort(); closePlayer(); inlineVideos().forEach(video => video.pause()); visibility.disconnect(); observer.disconnect(); };
      }
      disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xihe-hero-flexible"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('xihe-flexible-hero')) {
 customElements.define('xihe-flexible-hero', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const options = {signal:this.abort.signal};
   this.slides = [...this.querySelectorAll('.xf-slide')]; this.index = 0;
   this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
   this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
   this.hovered = false; this.focused = false; this.visible = true; this.editorSelected = false;
   this.toggle = this.querySelector('.xf-toggle');
   this.querySelector('.xf-controls')?.removeAttribute('hidden');
   this.addEventListener('click', e => {
    if(this.draggedUntil>Date.now() && e.target.closest('.xf-image-link')){e.preventDefault();return;} const button = e.target.closest('button'); if (!button) return;
    if (button === this.toggle) { this.paused = !this.paused; this.updateToggle(); this.schedule(); }
    else if (button.dataset.index !== undefined) this.go(Number(button.dataset.index), true);
    else if (button.dataset.step) this.go(this.index + Number(button.dataset.step), true);
   }, options);
   this.addEventListener('keydown', e => {
    if (e.target !== this && !e.target.closest('.xf-controls')) return;
    const keys = {ArrowLeft:this.index-1, ArrowRight:this.index+1, Home:0, End:this.slides.length-1};
    if (e.key in keys) { e.preventDefault(); this.go(keys[e.key], true); }
   }, options);
   this.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse' && this.dataset.pauseOnHover !== 'false'){this.hovered=true;this.schedule();} }, options);
   this.addEventListener('pointerleave', () => {if(this.hovered){this.hovered=false;this.schedule();}}, options);
   this.addEventListener('focusin', e => {this.focused=e.target.matches(':focus-visible');this.schedule();}, options);
   this.addEventListener('focusout', () => queueMicrotask(() => {this.focused=this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');this.schedule();}), options);
   this.addEventListener('pointerdown', e => { if(e.pointerType==='touch' && !e.target.closest('button,.xf-actions a,.xf-text a'))this.touch={x:e.clientX,y:e.clientY}; }, options);
   this.addEventListener('pointerup', e => { const t=this.touch;this.touch=null;if(!t||this.dataset.swipe!=='true')return;const dx=e.clientX-t.x,dy=e.clientY-t.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5){this.draggedUntil=Date.now()+400;this.go(this.index+(dx<0?1:-1),true);} }, options);
   this.addEventListener('pointercancel',()=>{this.touch=null;},options);
   document.addEventListener('visibilitychange',()=>this.schedule(), options);
   document.addEventListener('shopify:block:select', e => {const i=this.slides.findIndex(s=>s.dataset.block===e.detail.blockId);if(i>=0){this.editorSelected=true;this.go(i,false);}},options);
   document.addEventListener('shopify:block:deselect',()=>{this.editorSelected=false;this.schedule();},options);
   this.reduced.addEventListener('change',()=>{if(this.reduced.matches){this.paused=true;this.updateToggle();}this.schedule();},options);
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();});this.observer.observe(this);
   this.updateToggle(); this.updateControls(); this.schedule();
  }
  disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();this.slides?.forEach(s=>s.getAnimations().forEach(a=>a.cancel()));this.abort=null;}
  updateToggle(){if(this.toggle){const label=this.paused?this.dataset.play:this.dataset.pause;this.toggle.textContent=this.paused?'▷':'Ⅱ';this.toggle.setAttribute('aria-label',label);this.toggle.setAttribute('title',label);}}
  updateControls(){this.querySelectorAll('[data-index]').forEach(b=>{if(Number(b.dataset.index)===this.index)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});this.querySelectorAll('[data-step]').forEach(b=>{b.disabled=this.dataset.loop!=='true' && (Number(b.dataset.step)<0?this.index===0:this.index===this.slides.length-1);});const counter=this.querySelector('.xf-counter');if(counter)counter.textContent=`${this.index+1} / ${this.slides.length}`;}
  go(next, manual){
   if(!this.slides.length)return;
   if(this.dataset.loop==='true')next=(next+this.slides.length)%this.slides.length;else next=Math.max(0,Math.min(next,this.slides.length-1));
   if(next===this.index){this.schedule();return;}
   const old=this.slides[this.index], slide=this.slides[next];old.getAnimations().forEach(a=>a.cancel());old.hidden=true;old.inert=true;slide.hidden=false;slide.inert=false;this.index=next;
   if(!this.reduced.matches&&this.dataset.effect!=='none')slide.animate(this.dataset.effect==='slide'?[{opacity:0,transform:'translateX(3%)'},{opacity:1,transform:'translateX(0)'}]:[{opacity:0},{opacity:1}],{duration:parseFloat(getComputedStyle(this).getPropertyValue('--speed'))||0,easing:'ease-out'});
   if(manual){this.querySelector('.xf-status').textContent=slide.getAttribute('aria-label');}
   this.updateControls();this.schedule();
  }
  schedule(){clearTimeout(this.timer);this.classList.remove('xf-playing');if(this.slides.length<2||this.paused||this.hovered||this.focused||!this.visible||document.hidden||this.editorSelected)return;if(this.dataset.loop!=='true'&&this.index===this.slides.length-1)return;const seconds=Number(this.slides[this.index].dataset.duration)||Number(this.dataset.interval)||7;this.style.setProperty('--xf-delay',seconds+'s');void this.offsetWidth;this.classList.add('xf-playing');this.timer=setTimeout(()=>this.go(this.index+1,false),seconds*1000);}
 });
}

  } catch(e) { console.error(e); }
})();
})();
